module.exports = "<span class=\"beta-badge no-print\" :class=\"build+'-build'\">{{ build | proper-case}} v{{ version }}</span>\n"